module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-footy-lives-here-mobile.3ecc80b7.jpg";